import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appInitials',
    standalone: false
})
export class AppInitialsPipe implements PipeTransform {
    transform(appName: string, maxResult = 2): string {
        const words = appName.split(' ');
        return words
            .map(w => w.charAt(0))
            .join('')
            .slice(0, maxResult);
    }
}
